<template>
  <footer class="mt-0">
    <div v-if="template" class="container-fluid footer content-desktop border-top-light">
      <div class="container footer border-left-light pt-md-5 d-lg-flex px-md-4 px-lg-5">
        <div class="row patrocinadores d-lg-none">
          <div class="col-12 text-center pb-5">
            <div class="mt-5" v-if="template.header.showSomos">
               <inline-svg :src="templateHeader.icPeoples" :fill="[!secondaryFooter || template.style.surveyBgColor ? template.style.firstColor : 'text-survey-color']" width="120" height="50"></inline-svg>
              <h2
                class="m-0 p-0 text-uppercase"
                :class="[!secondaryFooter || template.style.surveyBackground ? 'text-first-color' : 'text-survey-color']"
                style="font-size: 2rem !important; line-height: 2rem; font-weight: 900 !important "
              >
                {{ $t('we_are_already') }}
              </h2>
              <h2
                class="extra-bold m-0 p-0"
                :class="[!secondaryFooter || template.style.surveyBackground ? 'text-first-color' : 'text-survey-color']"
              >
                {{template.header.somosSurveyNumber ? qtSurveyNumber : qtSomos | formatLocale }}
              </h2>
            </div>
          </div>
        </div>

        <div
          class="pb-3 mobile-display-logos d-flex justify-content-center align-items-center
                    justify-content-lg-start px-md-0 ml-lg-n4 col-lg-7 pb-lg-5 "
        >
          <p
            v-if="template.footer.logos.length"
            class="col-12 col-md-auto float-md-left light text-center pt-2 pl-md-4"
            :class="[!secondaryFooter || template.style.surveyBgColor ? defaultTextColor : 'text-black']"
          >
            <small>Powered by</small>
          </p>
          <div
            v-for="(item, index) in template.footer.logos"
            :key="index"
            class="col-12 text-center col-lg-auto float-lg-left pl-lg-2 ml-md-3 mb-3"
          >
            <img :src="[!secondaryFooter || template.style.surveyBgColor ? item.logo : item.logoSecondary]" :alt="item.alt" :height="item.height" />
          </div>
        </div>

        <div class="col-lg-5 text-center text-lg-right pb-4 pt-md-2 mb-lg-0">
          <nav>
<!--            <router-link to="/contact" class="btn btn-link" :class="[!secondaryFooter || template.style.surveyBackground ? 'text-white' : 'text-black']">-->
<!--              <small>Entre em contato</small>-->
<!--            </router-link>-->
            <router-link v-if="thereIsNoTextTermsDefined || isTextTermsDefinedWithMoreThanOneLine" to="/terms" class="btn btn-link" :class="[!secondaryFooter || template.style.surveyBgColor ? defaultTextColor : 'text-black']">
              <small class="mr-lg-4 justify-content-lg-start">{{ $t('terms_use_and_privacy') }}</small>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: 'FooterGlobal',
  props: {
    secondaryFooter: { type: Boolean },
    qtSomos: { type: Number },
    qtProjNumber: { type: Number },
  },
   components: {
    InlineSvg,
  },
  data: () => ({}),
  created() {},
  computed: {
    defaultTextColor() {
      return this.template.style.defaultTextColor ? this.template.style.defaultTextColor : 'white'
    },
    thereIsNoTextTermsDefined() {
      if (this.template.terms) {
        return (!this.template.terms.homeTextTerms)
      }
      return true
    },
    isTextTermsDefinedWithMoreThanOneLine() {
      if (this.template.terms) {
        return (this.template.terms.homeTextTerms && this.template.terms.homeTextTerms.length > 1)
      } else {
        return false
      }
    },
    template() {
      if (Object.keys(this.$store.state.template).length) {
        return this.$store.state.template;
      }
      return false
    },
     templateHeader() {
      return this.$store.state.template.header;
    },
     templateStyle(){
      return this.$store.state.template.style
    },
    qtSurveyNumber(){
      return this.$store.state.qtProjNumber;
    }
  },
  methods: {},
}
</script>

<style scoped>
.mobile-display-logos {
  flex-flow: wrap !important;
}
</style>
